import React, {useState, useEffect} from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import {DashboardAPI, DashboardFilterAPI, getCallersAPI} from "./../../API/Marketing/DashboardAPI";
import Layout from "./Layout";
import ContentLoader from "../../utils/ContentLoader";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";


const Dashboard = () =>{

	const [totalleadcount, setTotalLeadCount] = useState(0);
	const [connectedcount, setConnectedCount] = useState(0);
	const [applicationcount, setApplicationCount] = useState(0);
	const [admissioncount, setAdmissionCount] = useState(0);

	const [campaignlist, setCampaignList] = useState([]);
	const [callers, setCallers] = useState([]);
	const [leadfunnel, setLeadFunnel] = useState([]);
	const [topsources, setTopSources] = useState([]);
	const [topprograms, setTopPrograms] = useState([]);
	
	const [loggedname, setLoggedName] = useState("");

	//const [callerdata, setCallerData] = useState([]);
	const [loading, setLoading] = useState(true);
	//const [notifications, setNotifications] = useState([]);
	//const [campaigns, setCampaigns] = useState([]);

	//const [filtercampaign, setFilterCampaign] = useState("");
	const [filtercaller, setFilterCaller] = useState("");
	const [filterstartdate, setFilterStartdate] = useState("");
	const [filterenddate, setFilterEnddate] = useState("");
	const [filterparam, setFilterParam] = useState("");
	//const [btnimportloader, setBtnImportLoader] = useState(false);
	//const [btnexportloader, setBtnExportLoader] = useState(false);

	const [topfiltersDraft, setTopFiltersDraft] = useState({                                                    
                                                    filterstartdate: "",
                                                    filterenddate: ""
                                                });

	const current = moment();

	useEffect(() =>{

		const userinfo = localStorage.getItem("userinfo");

		if(userinfo !== "" && userinfo !== null && userinfo !== undefined)
        {
            const loggeduserdata = JSON.parse(userinfo);

            setLoggedName(loggeduserdata.name);
        }

		DashboardAPI(setTotalLeadCount, setConnectedCount, setApplicationCount, setAdmissionCount, setCampaignList, setLeadFunnel, setTopSources, setTopPrograms, setLoading);

		//getCampaignsAPI(setCampaigns);
		
	}, []);

	const handleReloadStats = () =>{
		DashboardAPI(setTotalLeadCount, setConnectedCount, setApplicationCount, setAdmissionCount, setCallers, setLeadFunnel, setTopSources, setTopPrograms, setLoading);
	}

	const handleFilterCampaign = (e) =>{
		//setFilterCampaign(e.target.value);

		getCallersAPI(e.target.value, setCallers);
	}

	const handleFilterCaller = (e) =>{
		setFilterCaller(e.target.value);
	}

	const handleStartDate = (e) =>{
		setFilterStartdate(e.target.value);
	}

	const handleEndDate = (e) =>{
		setFilterEnddate(e.target.value);
	}

	

	const handleFilterDateRange = (dates) => {

        console.log("Created Dates====" + dates);

        if (!dates || (!dates[0] && !dates[1])) 
        {
            
            console.log("created false condition");
            
            setFilterStartdate(null);
            setFilterEnddate(null);

            /*setTopFiltersDraft(prev => ({
                                ...prev,
                                filterstartdate: "",
                                filtercreatedenddate: ""
                            }));*/

            DashboardAPI( setTotalLeadCount, setConnectedCount, setApplicationCount, setAdmissionCount, setCampaignList, setLeadFunnel, setTopSources, setTopPrograms, setLoading, null);

	        return;
        }

        const [start, end] = dates;

	    setFilterStartdate(start);
	    setFilterEnddate(end);

	    if (start && end) {

	        const params = new URLSearchParams();

	        params.append("start_date", format(start, "yyyy-MM-dd"));
	        params.append("end_date", format(end, "yyyy-MM-dd"));

	        DashboardAPI(setTotalLeadCount, setConnectedCount, setApplicationCount, setAdmissionCount, setCampaignList, setLeadFunnel, setTopSources, setTopPrograms, setLoading, params);
	    }
        

        /*if(!filterstartdate && !filterenddate)
        {
        	DashboardAPI(setTotalLeadCount, setConnectedCount, setApplicationCount, setAdmissionCount, setTeamList, setLeadFunnel, setTopSources, setTopPrograms, setLoading, topfiltersDraft);
        }*/

    }



    return(
	<Layout>
		<div className="content">
			<div class="welcome-wrap mb-4">
				<div class=" d-flex align-items-center justify-content-between flex-wrap crm-welcome-bar">
					<div class="mb-3">
						<h2 class="mb-1 text-white">Welcome {loggedname}</h2>
						<p class="text-light">As of {current.format('DD MMMM YYYY')} {current.format('hh:mm A')}</p>
					</div>
					
					<div class=" d-flex align-items-center justify-content-between mb-1 crm-top-actions">
						{/*<a href="company.html" class="btn btn-dark btn-md me-2 mb-2">Companies</a>*/}
						<button type="button" class="btn btn-light btn-md mb-2 mx-2" onClick={handleReloadStats}>Refresh</button>

						<DatePicker className="form-control" selected={filterstartdate} onChange={ handleFilterDateRange } startDate={filterstartdate} endDate={filterenddate} selectsRange isClearable placeholderText="Created Date" />

						{/*<button type="button" class="btn btn-light btn-md mb-2 mx-2" onClick={handleAutoAssignLeads}>Auto Lead Assign</button>
					
						<button type="button" class="btn btn-light btn-md mb-2 mx-2" onClick={handleGoogleDriveLeads}>Import Google Drive Leads</button>
						
						<button type="button" class="btn btn-light btn-md mb-2" onClick={handleExportLeadsGoogleDrive}>Export Leads Google Drive</button>*/}
						
						
					</div>
				</div>
			</div>			

			<div className="row crm-stats-row">
				<div className="col-md-3">
					<div className="card fresh">
						<div className="card-body p-3 d-flex align-items-center mx-auto">
							<div>
								<div className="fs-25 fw-semibold widget-text text-center">{totalleadcount}</div>
								<div className="text-body-secondary fw-semibold widget-heading">Total Leads</div>
							</div>
						</div>
						<div className="card-footer px-3 py-2">
							<div class="footer-content">
								<Link className="btn-block text-body-secondary d-flex justify-content-between align-items-center" to={`/team/lead/freshlead${filterparam}`}>
									<span className="small fw-semibold">View all</span>
									<span>
										<svg xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  strokeWidth="2"  strokeLinecap="round"  strokeLinejoin="round"  className="icon icon-tabler icons-tabler-outline icon-tabler-arrow-right">
											<path stroke="none" d="M0 0h24v24H0z" fill="none"/>
											<path d="M5 12l14 0" />
											<path d="M13 18l6 -6" />
											<path d="M13 6l6 6" />
										</svg>
									</span>
								</Link>
							</div>
						</div>
					</div>
				</div>
				<div className="col-md-3">
					<div className="card follow">
						<div className="card-body p-3 d-flex align-items-center mx-auto">
							<div>
								<div className="fs-25 fw-semibold widget-text text-center">{connectedcount}</div>
								<div className="text-body-secondary fw-semibold widget-heading">Connected</div>
							</div>
						</div>
						<div className="card-footer px-3 py-2">
							<div class="footer-content">
								<Link className="btn-block text-body-secondary d-flex justify-content-between align-items-center" to={`/team/notification/today${filterparam}`}>
									<span className="small fw-semibold">View all</span>
									<span>
										<svg xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  strokeWidth="2"  strokeLinecap="round"  strokeLinejoin="round"  className="icon icon-tabler icons-tabler-outline icon-tabler-arrow-right">
											<path stroke="none" d="M0 0h24v24H0z" fill="none"/>
											<path d="M5 12l14 0" />
											<path d="M13 18l6 -6" />
											<path d="M13 6l6 6" />
										</svg>
									</span>
								</Link>
							</div>
						</div>
					</div>
				</div>

				<div className="col-md-3">
					<div className="card warm">
						<div className="card-body p-3 d-flex align-items-center mx-auto">
							<div>
								<div className="fs-25 fw-semibold widget-text text-center">{applicationcount}</div>
								<div className="text-body-secondary fw-semibold widget-heading">Application</div>
							</div>
						</div>
						<div className="card-footer px-3 py-2">
							<div class="footer-content">
								<Link className="btn-block text-body-secondary d-flex justify-content-between align-items-center" to={`/team/lead/warmleads${filterparam}`}>
									<span className="small fw-semibold">View all</span>
									<span>
										<svg  className="icon" xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-arrow-right">
											<path stroke="none" d="M0 0h24v24H0z" fill="none"/>
											<path d="M5 12l14 0" />
											<path d="M13 18l6 -6" />
											<path d="M13 6l6 6" />
										</svg>
									</span>
								</Link>
							</div>
						</div>
					</div>
				</div>

				<div className="col-md-3">
					<div className="card pending">
						<div className="card-body p-3 d-flex align-items-center mx-auto">
							<div>
								<div className="fs-25 fw-semibold widget-text text-center">{admissioncount}</div>
								<div className="text-body-secondary fw-semibold widget-heading">Admission</div>
							</div>
						</div>
						<div className="card-footer px-3 py-2">
							<div class="footer-content">
								<Link className="btn-block text-body-secondary d-flex justify-content-between align-items-center" to={`/team/notification/pending${filterparam}`}>
									<span className="small fw-semibold">View all</span>
									<span>
										<svg xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  strokeWidth="2"  strokeLinecap="round"  strokeLinejoin="round"  className="icon icon-tabler icons-tabler-outline icon-tabler-arrow-right">
											<path stroke="none" d="M0 0h24v24H0z" fill="none"/>
											<path d="M5 12l14 0" />
											<path d="M13 18l6 -6" />
											<path d="M13 6l6 6" />
										</svg>
									</span>
								</Link>
							</div>
						</div>
					</div>
				</div>

			</div>

			<div className="row crm-report-row">
				<div className="col-md-12">
					<div className="card w-100 crm-big-report-card">
						<div className="card-header border-0 pb-0">
							<h4 className="mb-2">
								<i className="ti ti-grip-vertical me-1"></i>Campaign Performance
							</h4>
						</div>
						<div className="card-body">
							{loading ?
								<ContentLoader />
							:

							<div className="table-responsive crm-report-table-wrap">
								<table class="table table-nowrap mb-0">
									<thead class="thead-light">
										<tr>
											<th>Campaign Name</th>
											<th>Total</th>
											<th>Contacted</th>
											<th>Application</th>
											<th>Admission</th>
										</tr>
									</thead>
									<tbody>

									{
									campaignlist && campaignlist.length > 0  ?
										campaignlist.map(campaigndata =>
											(
												<tr key={campaigndata.id}>
													<td>
														<div class="avatar avatar-sm border flex-shrink-0 me-2">
															<span class="initials">{(campaigndata.name).slice(0,2)}</span>
														</div>
														{campaigndata.name}
													</td>
													<td>{campaigndata.totalcount}</td>
													<td>{campaigndata.connectedcount}</td>
													<td>{campaigndata.applicationcount}</td>
													<td>{campaigndata.admissioncount}</td>
												</tr>

											)
										)

									:

										<p>
											<center>No records found</center>
										</p>
									
									}
									</tbody>
								</table>
							</div>
							}
						</div>
					</div>
				</div>

			</div>


		</div>
	</Layout>
    )
}

export default Dashboard;
